var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.054 3.73203L15.9705 7.98153L12 9.68253L2.1405 5.45703C2.3625 5.23053 2.634 5.04753 2.943 4.92903L6.054 3.73203ZM8.061 2.96103L10.386 2.06703C11.4254 1.66744 12.5761 1.66744 13.6155 2.06703L21.0585 4.92903C21.366 5.04903 21.6375 5.22903 21.8595 5.45703L17.8755 7.16403L8.061 2.96103ZM22.491 6.81903L12.75 10.9935V22.1685C13.045 22.1185 13.3335 22.0395 13.6155 21.9315L21.0585 19.068C21.4828 18.9046 21.8477 18.6165 22.105 18.2416C22.3623 17.8668 22.5001 17.4227 22.5 16.968V7.02903C22.5 6.95903 22.4965 6.88903 22.4895 6.81903M11.25 22.1685V10.9935L1.5105 6.81903C1.50455 6.88888 1.50105 6.95893 1.5 7.02903V16.968C1.50006 17.4229 1.63799 17.8671 1.8956 18.242C2.1532 18.6169 2.51839 18.9049 2.943 19.068L10.3845 21.9315C10.6665 22.0395 10.955 22.1185 11.25 22.1685Z",
    fill: "#161941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders_icon.2d987d39ae4dde84c2247cc92aae87cc.svg";
export { ForwardRef as ReactComponent };